module.exports = __webpack_public_path__ + "cd4599538b11710332433917e1b86d9b.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/2000_r_30.mp3
// module id = 422
// module chunks = 0